import React, { useContext } from 'react';
import { ShopContext } from '../Context/ShopContext';
import { useParams } from 'react-router-dom';

import ProductDisplay from '../Components/ProductDisplay/ProductDisplay';

import RelatedProduct from '../Components/RelatedProduct/RelatedProduct';

const Product = () => {
  const { all_product } = useContext(ShopContext);
  const { productId } = useParams();
  const product = all_product.find((e) => e.id === Number(productId));
  return (
    <div className='my-5'>
      {/* Corrected prop name to 'product' */}
      {/* <BreadCrumbs product={product} /> */}
      <ProductDisplay product={product}/>
      {/* <DescriptionBox/> */}
      <RelatedProduct/>
    </div>
  );
};

export default Product;
